import React from 'react';
import { Box, LoadingSpinner } from 'edenred-ui';
import { useTranslation } from 'react-i18next';

import { CreateBenefitGroupForm } from '@epi-forms/BenefitGroup';
import {
  BenefitGroupName,
  LunchSettings,
  SelectBenefitsBar
} from '@epi-shared/components';
import { useGetDefaultBenefitGroupsSettingsQuery } from '@epi-api/benefitGroups';
import { MyChoiceBenefit } from '@epi-shared/components/BenefitGroups/SettingsSections/MyChoiceBenefit/MyChoiceBenefit';
import { BenefitType } from '@epi-constants/benefitTypes';
import { IBenefits } from '@epi-models/containers/ManageBenefits';

export const CreateBenefitGroup = () => {
  const { t } = useTranslation();
  const { data: benefitsDefaultSettings, isLoading } =
    useGetDefaultBenefitGroupsSettingsQuery();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!benefitsDefaultSettings?.contractedBenefits.length) {
    return <div>{t('containers.benefit_groups.no_result')}</div>;
  }

  return (
    <CreateBenefitGroupForm defaultSettings={benefitsDefaultSettings}>
      <Box display="flex" flexDirection="column" gap={3}>
        <BenefitGroupName />
        <SelectBenefitsBar
          contractedBenefits={benefitsDefaultSettings.contractedBenefits}
        />
        <LunchSettings
          maxValue={
            benefitsDefaultSettings?.contractedBenefits.find(
              ({ benefitType }) => benefitType === BenefitType.Lunch
            )?.maxAmount
          }
        />
        <Box display="flex" flexDirection="row" flexWrap="wrap" gap={3} mt={1}>
          {benefitsDefaultSettings?.contractedBenefits.map(
            ({ benefitType, maxAmount, minAmount }) =>
              benefitType !== BenefitType.Lunch ? (
                <MyChoiceBenefit
                  benefitName={benefitType as IBenefits}
                  maxAmounts={[maxAmount, minAmount]}
                  key={`myChoiceBenefit-${benefitType}`}
                />
              ) : null
          )}
        </Box>
      </Box>
    </CreateBenefitGroupForm>
  );
};
